const host = 'https://get-payqin.ew.r.appspot.com/api'

export default host